const webauthn = () => document.getElementById('sign_in_with_security_key');

export default {
  signInForm: () => (
    document.getElementById('new_user')
  ),
  emailOnSignInForm: () => (
    document.getElementById('user_email')
  ),
  oneTimeCode: () => (
    document.getElementById('sign_in_with_one_time_code')
  ),
  webauthn,
  webauthnForm: () => webauthn().querySelector('form'),
  rememberDeviceCheckbox: () => document.getElementById('remember_on_device')
};
